module.exports = __webpack_public_path__ + "img/checkmark-white.187677a7.svg";